/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
export const noop = (...args) => { };
//# sourceMappingURL=noop.js.map